import React from 'react'

const Chip = ({
  children,
  className = '',
  href,
  onClick,
  as = 'a',
  stopPropagation = false,
  linkTitle,
  hasIcon = false
}) => {
  const Component = as === 'a' ? 'a' : 'button'
  const anchorProps =
    as === 'a' ? { href, title: linkTitle, role: 'button' } : {}

  return (
    <Component
      className={`flex h-9 items-center rounded-full bg-gray-200 px-4 py-1.5 align-middle text-sm font-medium text-gray-1100 hover:bg-gray-300 active:bg-gray-400 ${
        hasIcon ? 'pl-3 pr-4' : 'px-4'
      } ${className}`}
      onClick={(e) => {
        if (stopPropagation) {
          e.stopPropagation()
        }
        onClick?.(e)
      }}
      {...anchorProps}
    >
      {children}
    </Component>
  )
}
export default Chip
